// @flow
let worker: ?Worker = null

export function terminate () {
  if (worker) {
    console.warn('Terminating Recommendations Worker')
    worker.terminate()
    worker = null
  }
}

export function initialize (): Worker {
  if (worker) {
    terminate()
  }

  console.warn('Initializing Recommendations Worker')

  // $FlowFixMe
  const RecommendationsWorker = require('worker-loader?name=[hash].recommendations.wrkr.js!./worker.js')
  worker = new RecommendationsWorker()
  return worker
}

export function getWorker (): Worker {
  if (worker) {
    return worker
  }

  return initialize()
}

export default {
  terminate,
  initialize,
  getWorker,
}
